import { produce } from 'immer';
import { ALL_TOAST_TYPE_PROPERTIES } from '../../types/toastTypes';
import { ADD_TOAST, CLEAR_TOASTS_STATE, CLOSE_EXPIRED_TOASTS, CLOSE_TOAST } from '../actions/toastsActions';
const initialState = {
    toasts: []
};
const toastsReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_TOASTS_STATE: {
                return initialState;
            }
            case ADD_TOAST: {
                // If a toast with a matching key already exists, remove it and add the new one at the start of the stack:
                const toastIndex = draft.toasts.findIndex((toast) => toast.key === action.payload.key);
                if (toastIndex !== -1) {
                    draft.toasts.splice(toastIndex, 1);
                }
                // need to add timestamp:
                const toast = {
                    ...action.payload,
                    startTimestampMs: performance.now()
                };
                draft.toasts.unshift(toast);
                break;
            }
            case CLOSE_TOAST: {
                draft.toasts = draft.toasts.filter((toast) => toast.key !== action.payload);
                break;
            }
            case CLOSE_EXPIRED_TOASTS: {
                const nowMs = performance.now();
                draft.toasts = draft.toasts.filter((toast) => {
                    const { autoHideDuration } = ALL_TOAST_TYPE_PROPERTIES[toast.type];
                    if (!autoHideDuration) {
                        // not an auto-hide toast
                        return true;
                    }
                    // return true if toast was not fully shown (is expired):
                    const isExpired = nowMs > toast.startTimestampMs + autoHideDuration;
                    return !isExpired;
                });
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default toastsReducer;
